// Lejárt munkamenet a következő belépésig: az axios ezzel tartja vissza a védett kéréseket,
// a router pedig ezzel visz a belépőre, ha egy később lezáruló navigáció felülírná az átirányítást.
let ended = false;

export const sessionEnded = () => ended;

export const markSessionEnded = () => { ended = true; };

export const clearSessionEnded = () => { ended = false; };
